import { PdpSectionMeta } from '../types';

export function sortSectionMeta(sectionMeta: PdpSectionMeta[]): PdpSectionMeta[] {
  return [...sectionMeta].sort((a, b) => {
    return (a.order ?? Infinity) - (b.order ?? Infinity);
  });
}
